import { MATCH_ALL_BACKSLASHES } from '../constants/regexes';
import { DEFAULT_REDIRECT_AFTER_LOGIN } from '../constants/routes';
import { NAV_EXTERNALS } from './nav';

export const performRedirect = (redirectParam: string) => {
  let redirectPath: string;

  if (redirectParam) {
    /**
     * Plus signs change their meaning when encoded, decoded, and then parsed as a URL param.
     * Since the redirectParam is a URI encoded path that may include its own params, we
     * need to re-encode the plus signs so they don't get converted into spaces.
     * React Router already decoded the to query param when we initially set it in our state
     * So we don't need to decode yet again here
     */
    redirectPath = redirectParam.replace(/\+/g, '%2B');

    // verify the redirect path starts with a "/"
    // therefore it may not a be javascript action or something else encoded
    if (!redirectPath.startsWith('/') && !decodeURIComponent(redirectPath).startsWith('/')) {
      redirectPath = DEFAULT_REDIRECT_AFTER_LOGIN;
    }
  } else {
    redirectPath = DEFAULT_REDIRECT_AFTER_LOGIN;
  }
  // Remove any potential backslashes from the redirectPath (PL-105140)
  redirectPath = redirectPath.replace(MATCH_ALL_BACKSLASHES, '');

  NAV_EXTERNALS.cypressLocationReplace(redirectPath);
};
